module.exports = __webpack_public_path__ + "img/sabadell.a6fdf16e.png";